/**
 * @generated SignedSource<<900b80199afc9efa03c01e67aea1e3e8>>
 * @relayHash cfcfb33cef7d4219a6d3f24984f7bcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type splitIssueModalQuery$variables = {
  boardId: string;
  cardId: string;
};
export type splitIssueModalQuery$data = {
  readonly canSplitIssue: boolean;
};
export type splitIssueModalQuery = {
  response: splitIssueModalQuery$data;
  variables: splitIssueModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cardId"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "boardId",
      "variableName": "boardId"
    },
    {
      "kind": "Variable",
      "name": "cardId",
      "variableName": "cardId"
    }
  ],
  "kind": "ScalarField",
  "name": "canSplitIssue"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "splitIssueModalQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "canSplitIssue"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "splitIssueModalQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d",
    "metadata": {},
    "name": "splitIssueModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c5280b41e46526652e1eaef4fc47ef2";

export default node;
